import { LayoutDashboard } from "lucide-react";
import type { ShellNavGroup, ShellNavItem } from "@/components/shell/AppShell";

/**
 * Navigation for the STAFF area (event-day workers).
 *
 * Reuses the shared AppShell. Staff see a minimal nav — Home only (the
 * big-button launcher) plus the user menu. They do NOT see any
 * admin / coach / org-admin configuration items.
 */
export const staffNav: ShellNavGroup[] = [
  {
    items: [{ label: "Home", href: "/staff/home", icon: LayoutDashboard }],
  },
];

export const staffFooterNav: ShellNavItem[] = [];
